import React, { Component } from 'react';
import { array, number, shape, string } from 'prop-types';

import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';

class Screen extends Component {
  static propTypes = {
    boxes: array.isRequired,
    className: string.isRequired,
    id: string.isRequired,
    mainContent: shape({
      content: string.isRequired,
      header: string.isRequired,
      id: number.isRequired
    }),
    screenHeight: number.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      activeBox:
        props.slug !== undefined
          ? { ...this.props.boxes[0] }
          : { ...this.props.mainContent }
    };
  }

  changeActiveContentHandler = ({ content, header, link, id }) => {
    this.setState({
      activeBox: {
        link,
        content,
        header,
        id
      }
    });
  };

  render() {
    const { boxes, className, id, mainContent, screenHeight } = this.props;
    const { activeBox } = this.state;
    const isMobile = window.innerWidth < 992;
    let styles = {};

    isMobile
      ? (styles.minHeight = `${screenHeight}px`)
      : (styles.height = `${screenHeight}px`);

    return (
      <div
        id={id}
        className={isMobile ? `${className} flex-column` : className}
        style={styles}
      >
        {isMobile ? (
          <Mobile
            activeBox={activeBox}
            boxes={boxes}
            className={className}
            mainContent={mainContent}
            handleClick={box => this.changeActiveContentHandler(box)}
          />
        ) : (
          <Desktop
            activeBox={activeBox}
            boxes={boxes}
            handleClick={box => this.changeActiveContentHandler(box)}
            heightSm={this.props.heightSm}
          />
        )}
      </div>
    );
  }
}

export default Screen;



// WEBPACK FOOTER //
// ./src/components/Partners/Screen.jsx